import React from 'react';
import { CheckCircle2, Target, Eye, Heart } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-[#f4e5c3]/30 rounded-full">
              <span className="text-[#b8962e] font-semibold">O Nama</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-[#0f172a] mb-6 gold-underline">
              Gradimo S Strašću i Predanošću
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Dekor Art gradnja je vodeća građevinska tvrtka osnovana 2024. godine s vizijom 
              pružanja vrhunskih građevinskih usluga. Naš tim od 50+ visoko stručnih 
              i certificiranih profesionalaca posvećen je transformaciji vaših vizija u stvarnost.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Od početnih osnova visokogradnje do najsitnijih detalja završnih obrada, 
              pristupamo svakom projektu s istom razinom posvećenosti, preciznosti i strasti. 
              Vjerujemo da kvalitetna gradnja nije samo posao - to je umjetnost.
            </p>

            <div className="space-y-4 mb-8">
              {[
                'Certificirani stručnjaci s dugogodišnjim iskustvom',
                'Korištenje najkvalitetnijih materijala',
                'Poštivanje rokova i budžeta',
                'Ekološki održive građevinske prakse'
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-[#d4af37] flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <a 
              href="#contact" 
              onClick={(e) => {
                e.preventDefault();
                const element = document.querySelector('#contact');
                if (element) {
                  const headerOffset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }}
              className="btn-primary inline-block cursor-pointer"
            >
              Kontaktirajte Nas
            </a>
          </div>

          <div className="grid grid-cols-1 gap-6">
            <div className="bg-gradient-to-br from-[#0f172a] to-[#1e293b] p-8 rounded-2xl text-white">
              <Target className="w-12 h-12 text-[#d4af37] mb-4" />
              <h3 className="text-2xl font-bold mb-3">Naša Misija</h3>
              <p className="text-gray-300 leading-relaxed">
                Pružiti klijentima vrhunske građevinske usluge koje nadmašuju očekivanja, 
                kombinirajući tradiciju s inovacijom, kvalitetu s pouzdanošću.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#d4af37] to-[#b8962e] p-8 rounded-2xl text-white">
              <Eye className="w-12 h-12 text-white mb-4" />
              <h3 className="text-2xl font-bold mb-3">Naša Vizija</h3>
              <p className="leading-relaxed">
                Biti vodeći izbor za građevinske projekte u regiji, prepoznati po 
                izvrsnosti, inovaciji i bezuvjetnoj predanosti kvaliteti.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#1e293b] to-[#334155] p-8 rounded-2xl text-white">
              <Heart className="w-12 h-12 text-[#d4af37] mb-4" />
              <h3 className="text-2xl font-bold mb-3">Naše Vrijednosti</h3>
              <p className="text-gray-300 leading-relaxed">
                Integritet, kvaliteta, sigurnost i održivost su temelji svakog našeg projekta. 
                Vaše zadovoljstvo je naš uspjeh.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;